"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function (tlSelectConfigRegistry, financeurSubventionSelectConfig, allFinanceurSubventionSelectConfig) {
  tlSelectConfigRegistry.registerConfig("financeur-subvention", financeurSubventionSelectConfig);
  tlSelectConfigRegistry.registerConfig("all-financeur-subvention", allFinanceurSubventionSelectConfig);
});
ngModule.factory("financeurSubventionSearchMatcher", function (stringUtils) {
  return function (text, option) {
    return stringUtils.containsIgnoringCaseAndAccents(option.libelleJuridique, text) || stringUtils.containsIgnoringCaseAndAccents(option.libelleCourtUsuel, text) || stringUtils.containsIgnoringCaseAndAccents(option.departement, text) || stringUtils.containsIgnoringCaseAndAccents(option.groupLabel, text);
  };
});
ngModule.factory("financeurSubventionSelectConfig", function (financeurSubventionSearchMatcher, financeurSubventionSelectPopin) {
  return {
    idAttribute: "id",
    optionTemplate: require("./financeurOption.html"),
    optionsFilter: function optionsFilter(option) {
      return option.$inCompte;
    },
    sort: function sort(a, b) {
      var attrA = a.libelleCourtUsuel;
      var attrB = b.libelleCourtUsuel;
      return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
    },
    expandButton: {
      label: "Tous les financeurs",
      handler: function handler(ctrl) {
        ctrl.closeDropdown();
        financeurSubventionSelectPopin.open().then(function (selected) {
          ctrl.setSelectedOptionById(selected.id);
        });
      }
    },
    allowEmptySelect: false,
    matcher: financeurSubventionSearchMatcher
  };
});
ngModule.factory("allFinanceurSubventionSelectConfig", function (financeurSubventionSearchMatcher) {
  return {
    idAttribute: "id",
    optionTemplate: require("./financeurOption.html"),
    groupBy: "groupLabel",
    groupLabelTemplate: "<span>{{::group.value}}</span>",
    matcher: financeurSubventionSearchMatcher,
    allowEmptySelect: false
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/configs/finaceursSubvention/financeurSubventionSelectConfig.js
// module id = 2995
// module chunks = 13